import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import Vue from 'vue'
import {onMountCall} from '../main-files/firebase'
import videoModalMixin from '../mixins/videoModalMixin'
import store from '../store'

let domain = process.env.MIX_SOCKET_SERVER_DOMAIN
let protocol = process.env.MIX_SOCKET_SERVER_PROTOCOL
let port = process.env.MIX_SOCKET_SERVER_PORT

import { Api } from './axios'

const vueInstance = new Vue({
    mixins: [videoModalMixin],
    store
})

Api.get('/api/v1/admins/me')
    .then(async ({ data: { user } }) => {
        if (user) {
            // Show onboarding task university lesson video if needed
            await vueInstance.handleUserVideoDisplay()
            // Initialize progress footer only if not on /agents path

            // below send user id with socket headers
            onMountCall();
            (new Vue()).$socket.io.opts.extraHeaders = { user_id : user.id };
            (new Vue()).$socket.connect()
        }
    })
    .catch(e => {
        console.log('socket error', e)
    })


/* Establish Connection */
const socketConnection = SocketIO(`${protocol}://${domain}:${port}`, {
    debug: false,
    autoConnect : false,
    timeout: 2000
})

socketConnection.on('connect', () => {
    console.log('Socket Connected')
})

Vue.use(new VueSocketIO({
    debug: false,
    connection: socketConnection,
}))
